import { RiCalendarScheduleLine } from "@remixicon/react";
import React from "react";
import Button from "../theme/button/Button";
import Styles from "./Scheduler.module.scss";
import Popover from "../popover/Popover";
import TimeDisplay from "../time/Time";

export default function SchedulerIcon({
    scheduledDate,
    onClear,
}: {
    scheduledDate: Date,
    onClear: () => void;
}) {
    return (
        <Popover
            placement="top"
            buttonClassName={Styles["scheduled-comment"]}
            popoverClassName={Styles["scheduled-comment-popover"]}
            text={<RiCalendarScheduleLine />}
        >
            <div className={Styles["scheduled-comment-content"]}>
                Scheduled for
                <TimeDisplay date={scheduledDate} variant="date" />
                {" "}
                <TimeDisplay date={scheduledDate} variant="time" />
                {" "}
                <Button
                    size="xsmall"
                    variant="secondary"
                    isClose
                    onClick={onClear}
                >
                    Cancel
                </Button>
            </div>
        </Popover>
    );
}
